// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDaysAfterPlanEndPropertyDto
 */
export interface IDaysAfterPlanEndPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IDaysAfterPlanEndPropertyDto
     */
    days_after_plan_end?: number;
    /**
     * 
     * @type {string}
     * @memberof IDaysAfterPlanEndPropertyDto
     */
    days_after_plan_end_state?: IDaysAfterPlanEndPropertyDtoDaysAfterPlanEndStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDaysAfterPlanEndPropertyDtoDaysAfterPlanEndStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IDaysAfterPlanEndPropertyDto interface.
 */
export function instanceOfIDaysAfterPlanEndPropertyDto(value: object): value is IDaysAfterPlanEndPropertyDto {
    return true;
}

export function IDaysAfterPlanEndPropertyDtoFromJSON(json: any): IDaysAfterPlanEndPropertyDto {
    return IDaysAfterPlanEndPropertyDtoFromJSONTyped(json, false);
}

export function IDaysAfterPlanEndPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDaysAfterPlanEndPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'days_after_plan_end': json['days_after_plan_end'] == null ? undefined : json['days_after_plan_end'],
        'days_after_plan_end_state': json['days_after_plan_end_state'] == null ? undefined : json['days_after_plan_end_state'],
    };
}

export function IDaysAfterPlanEndPropertyDtoToJSON(json: any): IDaysAfterPlanEndPropertyDto {
    return IDaysAfterPlanEndPropertyDtoToJSONTyped(json, false);
}

export function IDaysAfterPlanEndPropertyDtoToJSONTyped(value?: IDaysAfterPlanEndPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'days_after_plan_end': value['days_after_plan_end'],
        'days_after_plan_end_state': value['days_after_plan_end_state'],
    };
}

